module.exports = __webpack_public_path__ + "img/Hypoxia-PRCA_10X_ACC.dfc22bbb.png";